import React from 'react';
import { Icon } from './Icon.js';
export const IconCheckBoxArrow = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 3V16.7578L20 14.7578V5H4V19H21V21H2V3H22Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" }),
        React.createElement("path", { d: "M18.5 17.5L21 20L18.5 22.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M8.5 12L11 14.5L16 9.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCheckBoxArrow.js.map